/*
  assets/product-video-swipe.js

  Pairs with `assets/product-video-swipe.css`, which leaves a YouTube/Vimeo embed
  in the product media gallery inert on touch devices so the gallery can still be
  swiped. This hands control to the player on the first tap, and takes it back
  when the slide leaves the screen.

  Why a tap rather than leaving the embed inert for good: muted autoplay is all
  the customer gets otherwise. Sound, scrubbing and fullscreen are all inside the
  iframe, so something has to let them through eventually.

  Why it is given back on exit: without that, swiping away and back leaves the
  slide stuck again, and the customer has no way to know why one video traps the
  gallery and the next does not.

  Nothing here runs on desktop. The CSS only makes the embed inert under
  `(hover: none) and (pointer: coarse)`, and the guard below keeps the listeners
  off everywhere else so a mouse click never has to be spent on activation.
*/
(function () {
  var ACTIVE = 'video-interactive';
  var SELECTOR = '.product__media-gallery video-element[source]';

  var coarse = window.matchMedia('(hover: none) and (pointer: coarse)');
  if (!coarse.matches) return;

  /*
    Delegated, because the gallery is re-rendered on variant change - the vendor
    `media-gallery.js` rewrites `video-element` markup wholesale - and a listener
    bound to the elements themselves would be dropped on the floor.

    The click can only land here while the embed is inert; once it is active the
    iframe swallows everything, so this cannot fire twice for the same element.
  */
  document.addEventListener('click', function (event) {
    var media = event.target.closest(SELECTOR);
    if (!media || media.classList.contains(ACTIVE)) return;

    media.classList.add(ACTIVE);
  });

  if (!('IntersectionObserver' in window)) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) entry.target.classList.remove(ACTIVE);
      });
    },
    // Most of the slide has to be gone before control is taken back, or the
    // threshold trips while the customer is still watching a part-scrolled slide.
    { threshold: 0.25 }
  );

  var observed = new WeakSet();
  function observeAll() {
    document.querySelectorAll(SELECTOR).forEach(function (media) {
      if (observed.has(media)) return;
      observed.add(media);
      observer.observe(media);
    });
  }

  observeAll();
  // Same reason as the delegated click: the gallery can be replaced after a
  // variant change, and the replacements need observing too.
  new MutationObserver(observeAll).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
